import { useNbTheme } from '../hooks/useNbTheme';

export default function ThemeToggleNB() {
  const { theme, toggleTheme } = useNbTheme();

  return (
    <button
      onClick={toggleTheme}
      className="font-nb font-bold text-sm px-3 py-1.5 border-3 border-current rounded-[2px] transition-transform duration-200 hover:translate-x-1"
      style={{
        color: theme === 'light' ? '#000000' : '#FFFFFF',
        background: 'transparent',
      }}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
    >
      {theme === 'light' ? '🌙 Dark' : '☀️ Light'}
    </button>
  );
}
